// see documentation of potential strategy values here: https://auth0.com/docs/api/management/v2/connections/get-connections
export const strategyDisplayNameMap: Record<string, string> = {
  okta: 'Okta',
  adfs: 'ADFS',
  waad: 'Entra ID',
  'google-apps': 'Google Workspace',
  ad: 'Active Directory / LDAP',
  samlp: 'Custom SAML',
  oidc: 'Custom OIDC',
  office365: 'Microsoft Azure AD',
  pingfederate: 'Ping Federate',
}
